import containerTemplate from './template'
import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../common/props'

import defaultLoader from '../common/defaultLoaderTemplate'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-dialog-wrapper',

  url: ({ props }) => props.url,

  context: 'iframe',

  dimensions: {
    width: '100%',
    height: 'auto',
  },

  autoResize: {
    width: false,
    height: true,
  },

  containerTemplate,

  prerenderTemplate: defaultLoader,

  props: {
    ...commonComponentsProps,

    dialogContext: {
      type: 'object',
      required: true,
    },

    size: {
      type: 'string',
      required: true,
    },

    url: {
      type: 'string',
      required: true,
    },
    handleOpenChargebeeCheckout: {
      type: 'function',
      required: false
    }
  },
})

export default cdc
